

(function () {
  'use strict';

  var IDIOMA_POR_DEFECTO = 'es';

  var ATRIBUTOS = {
    'data-i18n-placeholder': 'placeholder',
    'data-i18n-aria-label': 'aria-label',
    'data-i18n-alt': 'alt',
    'data-i18n-content': 'content'
  };

  var diccionario = {};

  function resolver(clave) {
    var partes = clave.split('.');
    var actual = diccionario;

    for (var i = 0; i < partes.length; i++) {
      if (actual === null || typeof actual !== 'object') return undefined;
      actual = actual[partes[i]];
    }

    if (typeof actual === 'string' || Array.isArray(actual)) return actual;
    return undefined;
  }

  function t(clave) {
    var valor = resolver(clave);

    if (valor === undefined) {
      console.warn('[i18n] clave sin traducir:', clave);
      return clave;
    }

    return valor;
  }

  function aplicar(raiz) {
    var ambito = raiz || document;

    ambito.querySelectorAll('[data-i18n]').forEach(function (el) {
      var valor = resolver(el.getAttribute('data-i18n'));

      if (typeof valor === 'string') el.textContent = valor;
    });

    Object.keys(ATRIBUTOS).forEach(function (attr) {
      ambito.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var valor = resolver(el.getAttribute(attr));
        if (typeof valor === 'string') el.setAttribute(ATRIBUTOS[attr], valor);
      });
    });

    marcarLaMarca(ambito);
  }

  var SALTAR_MARCA = { SCRIPT: 1, STYLE: 1, TITLE: 1, TEXTAREA: 1, OPTION: 1 };

  function marcarLaMarca(ambito) {
    var raiz = ambito.body || ambito;
    if (!raiz || !raiz.querySelectorAll) return;

    var nodos = [];
    var mirador = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = mirador.nextNode())) {
      if (!n.nodeValue || n.nodeValue.toLowerCase().indexOf('vevvia') < 0) continue;
      var p = n.parentNode;
      if (!p || SALTAR_MARCA[p.nodeName]) continue;
      if (p.closest && p.closest('.marca, .pie__marca, .pie__cinta-pista, .puerta__marca, .hn, .hn-cajon')) continue;
      nodos.push(n);
    }

    nodos.forEach(function (nodo) {
      var texto = nodo.nodeValue;
      var frag = document.createDocumentFragment();
      var i = 0, puesto = false;

      while (i < texto.length) {
        var k = texto.toLowerCase().indexOf('vevvia', i);
        if (k < 0) break;

        var antes = k > 0 ? texto.charAt(k - 1) : '';
        var resto = texto.slice(k + 6);

        var esDireccion = antes === '@' || antes === '.' ||
                          /[A-Za-z0-9_-]/.test(antes) ||
                          (resto.charAt(0) === '.' &&
                           /[A-Za-z]/.test(resto.charAt(1)));

        if (esDireccion) { i = k + 6; continue; }

        if (k > i) frag.appendChild(document.createTextNode(texto.slice(i, k)));
        var span = document.createElement('span');
        span.className = 'marca';
        span.textContent = texto.substr(k, 6);
        frag.appendChild(span);
        i = k + 6;
        puesto = true;
      }

      if (!puesto) return;
      if (i < texto.length) frag.appendChild(document.createTextNode(texto.slice(i)));
      nodo.parentNode.replaceChild(frag, nodo);
    });
  }

  var URL_DICCIONARIO = window.VEVVIA_I18N_URL ||
    ('/assets/i18n/' + IDIOMA_POR_DEFECTO + '.json');

  var listo = fetch(URL_DICCIONARIO)
    .then(function (respuesta) {
      if (!respuesta.ok) {
        throw new Error('HTTP ' + respuesta.status + ' al pedir el diccionario');
      }
      return respuesta.json();
    })
    .then(function (datos) {
      diccionario = datos;
      aplicar(document);
      document.documentElement.lang = IDIOMA_POR_DEFECTO;
      document.dispatchEvent(new CustomEvent('i18n:listo'));
      return diccionario;
    })
    .catch(function (error) {

      console.error(
        '[i18n] No se pudo cargar el diccionario.\n' +
        'Recuerda que esto necesita un servidor HTTP: abrir el index.html ' +
        'con doble clic (file://) no funciona.\n' +
        'Prueba con:  python3 -m http.server 8000\n',
        error
      );
      document.dispatchEvent(new CustomEvent('i18n:error', { detail: error }));
      return {};
    });

  window.VEVVIA_I18N = {
    listo: listo,
    t: t,
    aplicar: aplicar,
    get diccionario() { return diccionario; }
  };
})();
